import React from 'react'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import getColumnList from './voucher-column-list'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import Input from '../../../form/component/Input'

const TABLE_STYLE = {
    tableLayout: 'auto',
}

const VoucherSearch = ({
    tableData,
    onChangeVoucherCode,
    onEnterVoucherCode,
    voucherCode,
}) => {
    const columnList = getColumnList()

    return (
        <React.Fragment>
            <ContentBox title="Search voucher">
                <Row bottom='S'>
                    <Column size={4}>
                        <Input
                            type="text"
                            name="value"
                            object={voucherCode}
                            onChange={onChangeVoucherCode}
                            onEnter={onEnterVoucherCode}
                            placeholder="voucher code" />
                    </Column>
                </Row>
            </ContentBox>

            <ContentBox title="Vouchers">
                <table className="default-table" style={TABLE_STYLE}>
                    <thead>
                        <tr>
                            {columnList.map(({ property, header }) => {
                                return (
                                    <th
                                        key={property}>
                                        {header}
                                    </th>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.objectList.map((row, index) => {
                            return (
                                <tr key={row['id']} className="table-row">
                                    {columnList
                                        .map(({ property, renderer }) => {
                                            const value = renderer ? renderer(row, property) : row[property]
                                            return (<td key={property}>{value}</td>)
                                        })}
                                </tr>
                            )
                        })}
                        {tableData.objectList.length === 0 && <tr className="table-row">
                            <td className="align-center" colSpan={columnList.length}>No vouchers found</td>
                        </tr> }
                    </tbody>
                </table>
            </ContentBox>
        </React.Fragment>
    )
}

VoucherSearch.propTypes = {
    tableData: PropTypes.object.isRequired,
    onChangeVoucherCode: PropTypes.func.isRequired,
    onEnterVoucherCode: PropTypes.func.isRequired,
    voucherCode: PropTypes.string.isRequired,
}

export default withLayout((VoucherSearch))



// WEBPACK FOOTER //
// ./src/modules/voucher/component/search/VoucherSearch.js